export const MODAL_MODES = {
  PUBLISH: 'publish',
  SCHEDULE_COMMENTING: 'schedule',
  UPLOAD: 'upload',
  HEADER_RTE: 'headerRTE',
  INFO_RTE: 'infoRTE',
};

export default MODAL_MODES;
